<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off" >
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="ADIANTAMENTOS"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/business-and-finance1.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/adiantamentos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>      
      <hr class="mt-0 mb-4" />
      <div class="form-row">
        <div class="form-group col-md-2">
          <label class="mr-2 font-weight-bold" style="color: #009688 ">NÚMERO:</label>
          <label id="numero" class="form-control-plaintext font-weight-bold text-primary">
            {{ ("00000" + entidade.numero).slice(-5)  }}</label>
        </div>
        <div class="form-group col-md-2">
          <label>Ofício N˚</label>
          <label id="oficio" class="form-control-plaintext font-weight-bold text-primary">
            {{ entidade.oficio }}</label>
        </div>
        <div class="form-group col-md-2" *ngIf="entidade.empenho" >
          <label>Empenho N˚</label>
          <label id="numero_" class="form-control-plaintext font-weight-bold">
            {{ ("00000" + entidade.empenho.numero).slice(-5) }}</label>
        </div>
        <div class="form-group offset-md-3 col-md-3">
          <label for="selectSituacao">Situação</label>
          <label class="form-control-plaintext">{{ obterSituacao(entidade.situacao) }}</label>
        </div>
      </div>
      <hr />
      <div class="form-row">
        <div class="form-group col-md-2">
          <label>Adiantamento</label>
          <label class="form-control-plaintext">
            {{ entidade.data_adiantamento }}</label>
        </div>
        <div class="form-group col-md-2">
          <label>Vencimento</label>
          <label class="form-control-plaintext">
            {{ entidade.data_vencimento }}</label>
        </div>
        <div class="form-group col-md-2">
          <label>Liberação</label>
          <label class="form-control-plaintext">
            {{ entidade.data_liberacao }}</label>
        </div>
        <div class="form-group col-md-2" *ngIf="entidadeForm.get('data_prestacao').value">
          <label>Data Prestação</label>
          <label class="form-control-plaintext">
            {{ entidade.data_prestacao }}</label>
        </div>
        <div *ngIf="entidadeForm.get('data_prestacao').value" class="form-group offset-md-1 col-md-3">
          <label>Parecer</label>
          <label class="form-control-plaintext">{{ obterParecer(entidade.parecer) }}</label>
        </div>
      </div>
      <hr class="mt-0" />
      <div class="form-row">
        <div class="form-group col-md-5">
          <label for="beneficiario">Nome</label>
          <label class="form-control-plaintext font-weight-bold">
            {{ entidade.beneficiario }}</label>
        </div>
        <div class="form-group col-md-4">
          <label for="cargo_beneficiario">Cargo</label>
          <label class="form-control-plaintext">
            {{ entidade.cargo_beneficiario }}</label>
        </div>
        <div class="form-group col-md-3">
            <label>Beneficiário</label>
            <label class="form-control-plaintext">{{ obterTipo(entidade.tipo_beneficiario) }}</label>
          </div>
      </div>
      <div class="form-row">
        <div class="form-group col-8">
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="banco">Banco</label>
              <label class="form-control-plaintext">
                {{ entidade.banco }}</label>
            </div>
            <div class="form-group col-md-2">
              <label for="agencia">Agência</label>
              <label class="form-control-plaintext">
                {{ entidade.agencia }}</label>
            </div>
            <div class="form-group col-md-3">
              <label for="numero_conta">Conta N˚</label>
              <label class="form-control-plaintext">
                {{ entidade.numero_conta }}</label>
            </div>
          </div>
          <div class="form-row">
              <div class="form-group col-md-3">
                <label for="valor_adiantado">Valor adiantamento</label>
                <label class="form-control-plaintext font-weight-bold">
                  {{ funcaoService.convertToBrNumber(entidade.valor_adiantado) }}</label>
              </div>
            </div>
        </div>
        <div class="form-group col-4">

        </div>

      </div>

      <hr />
      <div class="form-row">
        <div class="form-group col-md-3">
          <label>Motivo</label>
          <label class="form-control-plaintext">{{ obterEspecie(entidade.especie) }}</label>
        </div>
        <div class="form-group col-md-5" *ngIf="entidadeForm.get('especie').value === 'D'">
          <label>Destino</label>
          <label class="form-control-plaintext">{{ entidade.destino }}</label>
        </div>
        <div class="col-md-2" *ngIf="entidadeForm.get('especie').value === 'D'">
          <label>Data Partida</label>
          <label class="form-control-plaintext">{{ entidade.data_partida }}</label>
        </div>
        <div class="col-md-2" *ngIf="entidadeForm.get('especie').value === 'D'">
          <label>Data Retorno</label>
          <label class="form-control-plaintext">{{ entidade.data_chegada }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="motido"></label>
          <label class="form-control-plaintext">{{ entidade.motivo }}</label>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <table class="table table-eddy" *ngIf="listaDocumentos && listaDocumentos.length > 0">
        <thead>
          <tr>
            <th scope="col">Data Doc.</th>
            <th scope="col">Documento</th>
            <th scope="col">CNPJ</th>
            <th scope="col">Razão social</th>
            <th scope="col">Valor</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaDocumentos; let idx = index">
            <td style="width: 200px">{{item.data_documento | date:'dd/MM/yyyy':'GMT'}}</td>
            <td style="width: 150px">{{item.documento}}</td>
            <td style="width: 250px">{{item.cnpj}}</td>
            <td style="width: 30%">{{item.razao_social}}</td>
            <td style="width: 200px">{{item.valor_documento | number:'1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
